import { ImportResponse, NewProduct, Product, ProductId, ProductSelect, ProductSelect2 } from '@portal-front-end/models';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { API_SERVER_TOKEN } from '../api-server-token';
import { Update } from '@ngrx/entity';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class ProductsApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PRODUCTS_URL = `${this.apiServer}/products`;

    createProduct(newProduct: NewProduct): Observable<Product> {
        return this.http.post<Product>(`${this.PRODUCTS_URL}`, newProduct);
    }

    getProductsById(productId: ProductId): Observable<Product> {
        return this.http.get<Product>(`${this.PRODUCTS_URL}/${productId}`);
    }

    getProducts(): Observable<Product[]> {
        return this.http.get<Product[]>(this.PRODUCTS_URL);
    }

    getProductsByGtinOrDescription(term: string, orgId: string): Observable<ProductSelect[]> {
        return this.http.get<ProductSelect[]>(`${this.PRODUCTS_URL}/search`, {
            params: {
                'gtinOrDescription': term,
                'organisationId': orgId
            }
        });
    }

    getProductsByOrderCodeOrDescription(term: string): Observable<ProductSelect2[]> {
        return this.http.get<ProductSelect2[]>(`${this.PRODUCTS_URL}/order-code-desc-search`, {
            params: { 'orderCodeOrDescription': term }
        });
    }

    updateProduct(product: Update<Product>): Observable<Product> {
        return this.http.put<Product>(`${this.PRODUCTS_URL}/${product.changes.productId}`, product.changes);
    }

    deleteProduct(id: string | number): Observable<string | number> {
        return this.http.delete<string | number>(`${this.PRODUCTS_URL}/${id}`)
            .pipe(map(() => id));
    }

    uploadProductsFile(formData: FormData): Observable<ImportResponse> {
        return this.http.post<ImportResponse>(`${this.PRODUCTS_URL}/import`, formData);
    }
}
